import { useContext } from 'react';
import LeadModalContext from 'components/domain/lead/modal/LeadModalContext';
import { useTranslation } from 'react-i18next';
import GovernmentFieldValue from '../fields/GovernmentFieldValue';

const MainGuest = () => {
  const { t } = useTranslation();
  const { lead } = useContext(LeadModalContext);

  if (!lead) {
    return null;
  }

  return (
    <div data-testid="main-guest-information">
      <h3>
        {t('componentLead.modal.stayDetailsTab.guestInfo.mainGuestInformation')}
      </h3>

      {lead.passportID ||
      lead.passportCountryCode ||
      lead.guest?.identificationDocumentUrl ? (
        <p data-testid="main-guest-government-id">
          {t('componentLead.modal.stayDetailsTab.guestInfo.governmentID')}{' '}
          <strong>
            <GovernmentFieldValue
              passportID={lead.passportID}
              passportCountryCode={lead.passportCountryCode}
              identificationDocumentUrl={lead.guest?.identificationDocumentUrl}
            />
          </strong>
        </p>
      ) : null}

      {lead.phoneNumber ? (
        <p data-testid="main-guest-phone-number">
          {t('componentLead.modal.stayDetailsTab.guestInfo.phoneNumber')}{' '}
          <strong>{lead.phoneNumber}</strong>
        </p>
      ) : null}

      {lead.age ? (
        <p data-testid="main-guest-age">
          {t('componentLead.modal.stayDetailsTab.guestInfo.age')}{' '}
          <strong>
            {t('componentLead.modal.stayDetailsTab.guestInfo.yearsOld', {
              age: lead.age,
            })}
          </strong>
        </p>
      ) : null}
    </div>
  );
};

export default MainGuest;
